import { Col, Row } from "antd"
import React from "react"
import "./styles.less"

const MOIT_NOTI_LINK = "http://online.gov.vn/Home/WebDetails/87764?AspxAutoDetectCookieSupport=1"

export const LoginFooter = () => {
  return (
    <Row className={"footer"}>
      <Col span={24} className={"container"}>
        <Row className={"footer__content"} gutter={[24, 24]} justify={"space-between"}>
          {/* Combined Logo and Company Information Column */}
          <Col xs={24} sm={24} md={13} lg={13} xl={13}>
            <div className="footer__section footer__logo-company-section">
              <div className="footer__logo">
                <img alt="" src={"/assets/png/logo.png"} className="footer__logo-image" />
              </div>
              <div className="footer__company-info">
                <div className="footer__company-name">Công ty TNHH Công nghệ và Dịch vụ DTrack</div>
                <div className="footer__company-details">
                  <div className="footer__detail-item">
                    <span><span className="font-medium">Địa chỉ trụ sở:</span> Tầng 1, Tòa nhà International Plaza, Số 343 Phạm Ngũ Lão, Phường Bến Thành, Thành phố Hồ Chí Minh, Việt Nam</span>
                  </div>
                  <div className="footer__detail-item">
                    <span><span className="font-medium">Giấy chứng nhận Đăng ký Kinh doanh:</span> số 0317537788 do Sở Kế hoạch và Đầu tư Thành phố Hồ Chí Minh cấp ngày 26/10/2022</span>
                  </div>
                  <div className="footer__detail-item">
                    <span><span className="font-medium">Giấy chứng nhận đủ điều kiện buôn bán phân bón:</span> Số 205-24/GCN-BBP do Ủy ban nhân dân thành phố Hồ Chí Minh - Sở Nông nghiệp và Phát triển nông thôn cấp ngày 05/8/2024</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Links Column */}
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <div className="footer__section">
              <div className="footer__links-section">
                <ul className="footer__links-list">
                  <li className="footer__link-item">
                    <span className="footer__link-chevron">›</span>
                    <a href="https://demeter.vn/policy-and-information/chinh-sach-van-chuyen" className="footer__link">Vận chuyển và giao nhận</a>
                  </li>
                  <li className="footer__link-item">
                    <span className="footer__link-chevron">›</span>
                    <a href="https://demeter.vn/policy-and-information/chinh-sach-thanh-toan" className="footer__link">Phương thức thanh toán</a>
                  </li>
                  <li className="footer__link-item">
                    <span className="footer__link-chevron">›</span>
                    <a href="https://demeter.vn/policy-and-information/quy-dinh-su-dung" className="footer__link">Điều kiện giao dịch chung</a>
                  </li>
                  <li className="footer__link-item">
                    <span className="footer__link-chevron">›</span>
                    <a href="https://demeter.vn/policy-and-information/chinh-sach-bao-ve-thong-tin-ca-nhan-cua-nguoi-tieu-dung" className="footer__link">Chính sách bảo vệ thông tin cá nhân của người tiêu dùng</a>
                  </li>
                </ul>
              </div>
            </div>
          </Col>

          {/* BCT Certification */}
          <Col xs={24} sm={24} md={5} lg={5} xl={5}>
            <div className="footer__section">
              <div className="footer__bct">
                <a href={MOIT_NOTI_LINK} target="_blank" rel="noopener noreferrer">
                  <img
                    alt="Bộ Công Thương"
                    src={"/assets/png/footer-moit-noti.png"}
                    className="footer__bct-image"
                  />
                </a>
              </div>
            </div>
          </Col>
        </Row>
        <div className="footer__separator"></div>
        <div className="footer__copyright">
          Copyright © 2025 - All Rights Reserved.
        </div>
      </Col>
    </Row>
  )
}

export default LoginFooter
